const productVariantPickerScript = document.currentScript;

const hydrateProductVariantPicker = () => {
    const variantSelectors = Array.from(document.querySelectorAll(`input[type="radio"]`))

    const handleInputChange = (e) => {
        const input = e.target;
        const sectionId = productVariantPickerScript.dataset.sectionId;
        const url = `${location.pathname}?variant=${input.value}&section_id=${sectionId}`;

        fetch(url)
        .then(res => res.text())
        .then(html => {
            const temp = document.createElement("div")
            const newURL = new URL(url, location.origin);
            
            temp.innerHTML = html;
            document.querySelector("#product-media-info").outerHTML = temp.querySelector("#product-media-info").outerHTML;
            newURL.searchParams.delete("section_id");
            history.pushState({}, "", newURL.toString());
            hydrateProductVariantPicker();
        })
    }

    for(const input of variantSelectors) {
        input.addEventListener("change", handleInputChange);
    }
}

hydrateProductVariantPicker();